import { render, staticRenderFns } from "./SmallShadedCard.vue?vue&type=template&id=047cde3a"
import script from "./SmallShadedCard.vue?vue&type=script&lang=js"
export * from "./SmallShadedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports